import { CommonModule } from '@angular/common';
import { Component, HostListener, OnInit, inject } from '@angular/core';
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import {IonApp, IonRouterOutlet, IonMenu, IonHeader, IonToolbar,IonTitle, IonContent, IonList, IonItem, IonIcon, IonLabel,
  IonMenuToggle, IonFooter, IonTabBar, IonTabButton, IonText,Platform} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import {
  homeOutline, informationCircleOutline, mailOutline,
  calendarOutline, shieldCheckmarkOutline, documentTextOutline,
  imagesOutline, leafOutline, gridOutline, calendarNumberOutline,
  readerOutline, pricetagOutline, arrowBackOutline, arrowForwardOutline, personOutline,
  logInOutline, logOutOutline, createOutline, sparklesOutline, compassOutline,
  checkmarkCircleOutline, syncOutline, restaurantOutline, bedOutline,
  menuOutline, closeOutline
} from 'ionicons/icons';
import { filter } from 'rxjs';
import { StatusBar, Style } from '@capacitor/status-bar';
import { ScreenByPlatform } from './common/services/screen-by-platform';
import { Helper } from './common/services/helper';
import { LodgeStateService } from './services/lodge-state.service';
import { SettingsStateService } from './services/settings-state.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [RouterLink, RouterLinkActive,IonApp, IonRouterOutlet, IonMenu, IonHeader, IonToolbar,IonTitle, IonContent,
     IonList, IonItem, IonIcon, IonLabel,IonMenuToggle, IonFooter, IonTabBar, IonTabButton, IonText, CommonModule],
})
export class AppComponent implements OnInit {
  private platform = inject(Platform);
  private lodgeState = inject(LodgeStateService);
  private settingsState = inject(SettingsStateService);
  private helper = inject(Helper);
  private router = inject(Router);
  private screenByPlatform = inject(ScreenByPlatform);

  isMobileShell = false;
  defaultHighlightNotes = 'This website is online for demo purposes only. Content, booking details, and availability are sample information.';
  settings$ = this.settingsState.settings$;

  pages: Array<{ title: string; url: string; icon: string; hideInMobileMenu?: boolean }> = [];

  mobileTabs: Array<{ title: string; url: string; icon: string }> = [];

  private publicPages: Array<{ title: string; url: string; icon: string; hideInMobileMenu?: boolean }> = [
    { title: 'Home', url: '/home', icon: 'home-outline', hideInMobileMenu: true },
    { title: 'About', url: '/about', icon: 'information-circle-outline', hideInMobileMenu: true },
    { title: 'Amenities', url: '/amenities', icon: 'leaf-outline', hideInMobileMenu: true },
    { title: 'Experience', url: '/experience', icon: 'images-outline', hideInMobileMenu: true },
    { title: 'Offers', url: '/offers', icon: 'pricetag-outline', hideInMobileMenu: true },
    { title: 'Contact', url: '/contact', icon: 'mail-outline' },
    { title: 'Booking Info', url: '/booking-info', icon: 'calendar-outline', hideInMobileMenu: true },
    { title: 'Privacy Policy', url: '/privacy-policy', icon: 'shield-checkmark-outline' },
    { title: 'Terms & Conditions', url: '/tnc', icon: 'document-text-outline' },
    { title: 'Login', url: '/login', icon: 'log-in-outline' },
  ];

  private userPages: Array<{ title: string; url: string; icon: string; hideInMobileMenu?: boolean }> = [
    { title: 'Home', url: '/home', icon: 'home-outline', hideInMobileMenu: true },
    { title: 'About', url: '/about', icon: 'information-circle-outline', hideInMobileMenu: true },
    { title: 'Amenities', url: '/amenities', icon: 'leaf-outline' ,hideInMobileMenu: true},
    { title: 'Experience', url: '/experience', icon: 'images-outline',hideInMobileMenu: true },
    { title: 'Offers', url: '/offers', icon: 'pricetag-outline', hideInMobileMenu: true },
    { title: 'Dashboard', url: '/dashboard', icon: 'grid-outline', hideInMobileMenu: true },
    { title: 'Availability', url: '/availability', icon: 'calendar-number-outline',hideInMobileMenu: true },
    { title: 'View Booking', url: '/view-booking', icon: 'reader-outline', hideInMobileMenu: true },
    { title: 'Profile', url: '/profile', icon: 'person-outline', hideInMobileMenu: true },
    { title: 'Contact', url: '/contact', icon: 'mail-outline' },
    { title: 'Booking Info', url: '/booking-info', icon: 'calendar-outline',hideInMobileMenu: true },
    { title: 'Privacy Policy', url: '/privacy-policy', icon: 'shield-checkmark-outline' },
    { title: 'Terms & Conditions', url: '/tnc', icon: 'document-text-outline' },
    { title: 'Logout', url: '/logout', icon: 'log-out-outline' },
  ];

  private desktopOnlyPages = [
    { title: 'Backend Guide', url: '/admin-guide', icon: 'document-text-outline' },
  ];

  private publicTabs = [
    { title: 'Home', url: '/home', icon: 'home-outline' },
    { title: 'Experience', url: '/experience', icon: 'images-outline' },
    { title: 'Offers', url: '/offers', icon: 'pricetag-outline' },
    { title: 'Booking', url: '/booking-info', icon: 'calendar-outline' },
    { title: 'Amenities', url: '/amenities', icon: 'grid-outline' },
  ];

  private userTabs = [
    { title: 'Home', url: '/home', icon: 'home-outline' },
    { title: 'Dashboard', url: '/dashboard', icon: 'grid-outline' },
    { title: 'Offers', url: '/offers', icon: 'pricetag-outline' },
    { title: 'Booking', url: '/view-booking', icon: 'reader-outline' },
    { title: 'Profile', url: '/profile', icon: 'person-outline' },
  ];

  constructor() {
    addIcons({
      homeOutline, informationCircleOutline, mailOutline,
      calendarOutline, shieldCheckmarkOutline, documentTextOutline,
      imagesOutline, leafOutline, gridOutline, calendarNumberOutline,
      readerOutline, pricetagOutline, arrowBackOutline, arrowForwardOutline, personOutline,
      logInOutline, logOutOutline, createOutline, sparklesOutline, compassOutline,
      checkmarkCircleOutline, syncOutline, restaurantOutline, bedOutline,
      menuOutline, closeOutline
    });

    this.updateShellMode();
    this.updateNavigation();
  }

  async ngOnInit() {
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(() => this.updateNavigation());

    try {
      await Promise.all([
        this.lodgeState.refreshAll(),
        this.settingsState.refreshSettings(true),
      ]);
    } catch {
      // Keep the app shell visible even if a public API is temporarily unavailable.
    }
  }

  @HostListener('window:resize')
  updateShellMode() {
    const isMobileShell = window.innerWidth < 900;
    if (this.isMobileShell !== isMobileShell) {
      this.isMobileShell = isMobileShell;
      this.updateNavigation();
    }
  }

  private updateNavigation() {
    const isLoggedIn = this.isLoggedIn();
    const pages = isLoggedIn ? this.userPages : this.publicPages;
    this.mobileTabs = isLoggedIn ? this.userTabs : this.publicTabs;

    const isDesktopPlatform = this.screenByPlatform.checkDesktopPlatform();

    if (isDesktopPlatform) {
      this.pages = [...pages, ...this.desktopOnlyPages];
      return;
    }

    this.pages = this.isMobileShell
      ? pages.filter(page => !page.hideInMobileMenu)
      : pages;
  }

  private isLoggedIn() {
    const userData = this.helper.getUserData();
    const userToken = this.helper.getUserToken();
    return !!userData && !!userToken;
  }

  initializeApp(){
    this.platform.ready().then(async () => {
      if (this.platform.is('capacitor')) {
          await StatusBar.setBackgroundColor({ color: '#623E23' });
          await StatusBar.setStyle({ style: Style.Default });

          setTimeout(() => {
            document.documentElement.style.setProperty('--status-bar-bg', '#623E23');
          }, 1000);

        } 
    });
  }
}
